import { render, staticRenderFns } from "./PageReceive.vue?vue&type=template&id=1bbdf3cc&scoped=true&"
import script from "./PageReceive.vue?vue&type=script&lang=js&"
export * from "./PageReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdf3cc",
  null
  
)

export default component.exports